/**
 * Says when HR recorded a check-in or its calibration on someone's behalf
 * (HR UAT list #24, #26). The People Leader and the Team Member both see that
 * HR recorded it. HR's reason shows whenever the check-in carries it: the server
 * sends it to the People Leader, HR and the calibration room, not to the Team
 * Member (Victor, 13 Oct 2026).
 */
import React from 'react'
import { Info } from 'lucide-react'

/** When HR recorded the check-in on the People Leader's behalf, and HR's reason if this reader is told it. */
export interface RecordedByHr {
  at: string | null
  reason?: string | null
}

interface Props {
  recordedByHr?: RecordedByHr | null
  calibrationRecordedByHr?: boolean
}

const day = (iso: string | null) =>
  iso ? new Date(iso).toLocaleDateString('en-ZA', { day: 'numeric', month: 'long', year: 'numeric' }) : null

export function RecordedByHrNote({ recordedByHr, calibrationRecordedByHr }: Props) {
  if (!recordedByHr && !calibrationRecordedByHr) return null
  return (
    <div role="note" className="mb-4 flex items-start gap-2 rounded-lg border border-sky-200 bg-sky-50 px-3 py-2 text-sm text-sky-900">
      <Info className="mt-0.5 h-4 w-4 flex-shrink-0" />
      <div className="space-y-0.5">
        {recordedByHr && (
          <p>
            HR recorded this check-in on the People Leader&apos;s behalf
            {day(recordedByHr.at) ? ` on ${day(recordedByHr.at)}` : ''}: it was held outside the system.
            {recordedByHr.reason ? ` Reason given: ${recordedByHr.reason}` : ''}
          </p>
        )}
        {calibrationRecordedByHr && (
          <p>The calibration was held outside the system, and HR recorded the result.</p>
        )}
      </div>
    </div>
  )
}

export default RecordedByHrNote
